"use client";

// src/card-group.tsx
import * as React2 from "react";
import {
  Base,
  systemForwardRef,
  useStyleConfig
} from "@stepstone-genesis/system";
import { getValidChildren } from "@stepstone-genesis/utilities";

// src/context.tsx
import * as React from "react";
var CardGroupContext = React.createContext({
  groupRootStyles: {},
  variant: "default"
});
var useCardGroupContext = () => {
  const context = React.useContext(CardGroupContext);
  return context;
};

// src/styles.ts
var groupSpacing = (spacingBetween) => ({
  marginBottom: spacingBetween || "-1px",
  _last: {
    marginBottom: "spaceNone"
  }
});
var root = (borderRadius) => ({
  ...groupSpacing(),
  borderRadius: "radiusNone",
  _last: {
    borderBottomRightRadius: borderRadius,
    borderBottomLeftRadius: borderRadius
  },
  _first: {
    borderTopLeftRadius: borderRadius,
    borderTopRightRadius: borderRadius
  }
});
var styles = {
  root,
  groupSpacing
};

// src/card-group.tsx
var CardGroup = systemForwardRef(function CardGroup2({
  children,
  variant = "default",
  isFullWidth = false,
  spacingBetweenCards = "spaceS",
  ...rest
}, ref) {
  const validChildren = getValidChildren(children);
  const { CARD_GROUP_ROOT } = useStyleConfig("CARD_GROUP_ROOT", {
    props: {
      borderRadius: "radiusM"
    }
  });
  const { CARD_GROUP } = useStyleConfig("CARD_GROUP", {
    styles: {
      responsiveVariants: [
        {
          id: "card-group-is-full-width",
          prop: isFullWidth,
          variants: {
            true: styles.groupSpacing(),
            false: {
              ...variant === "spaced" ? styles.groupSpacing(spacingBetweenCards) : styles.root(CARD_GROUP_ROOT.props.borderRadius)
            }
          }
        }
      ]
    },
    props: {
      variant
    }
  });
  return /* @__PURE__ */ React2.createElement(
    CardGroupContext.Provider,
    {
      value: {
        ...rest,
        groupRootStyles: CARD_GROUP.styles,
        isFullWidth
      }
    },
    /* @__PURE__ */ React2.createElement(Base, { ref, element: "CARD_GROUP_CONTAINER", role: "group", ...rest }, validChildren)
  );
});
export {
  CardGroup,
  CardGroupContext,
  useCardGroupContext
};
